<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="manageAreaId" label="客户区域" :rules="[{ required: true, message: '请选择' }]">
        <CustomerAreaCascader  appId="cos_fbu" v-model:value="editForm.manageAreaId" :disabled="editForm.id" />
      </a-form-item>
      <a-form-item name="seller" label="客户负责人" :rules="[{ required: true, message: '请选择' }]">
        <UserSelect v-model:value="editForm.seller" placeholder="请选择客户负责人" allowClear :disabled="editForm.id" />
      </a-form-item>
      <a-form-item name="clueNum" label="新线索数量">
        <a-input-number v-model:value="editForm.clueNum" :min="0" :precision="0" :max="999999" placeholder="请输入" />
      </a-form-item>
      <a-form-item name="customerContractNum" label="新签约客户数量">
        <a-input-number v-model:value="editForm.customerContractNum" :precision="0"  :min="0" :max="999999" placeholder="请输入" />
      </a-form-item>
      <a-form-item name="customerDealAmount" label="老成交客户新商机额">
        <a-input-number v-model:value="editForm.customerDealAmount" :min="0" :precision="0"  :max="999999" placeholder="请输入" />
      </a-form-item>
      <a-form-item name="customerDealNum" label="新成交客户数量">
        <a-input-number v-model:value="editForm.customerDealNum" :precision="0"  :min="0" :max="999999" placeholder="请输入" />
      </a-form-item>
      <a-form-item name="customerPotentialNum" label="新潜在客户数量">
        <a-input-number v-model:value="editForm.customerPotentialNum" :precision="0"  :min="0" :max="999999" placeholder="请输入" />
      </a-form-item>

      <a-form-item name="monthDate" label="月度" :rules="[{ required: true, message: '请选择' }]">
        <a-date-picker v-model:value="editForm.monthDate" picker="month" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'

import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { customerConversionTaskSave, customerConversionTaskUpdate } from '@/api/gucangSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { CustomerConversionTaskSaveParams } from '@/typings/api/gucangSale'
import { DcMessage } from '@dc-platform/dc-components'
import dayjs from 'dayjs'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerConversionTaskSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: CustomerConversionTaskSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    editForm.value.monthDate = dayjs(row.monthDate)
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.id) {
        await customerConversionTaskUpdate({
          ...editForm.value,
          id: editForm.value.id,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_fbu'
        })
      } else {
        await customerConversionTaskSave({
          ...editForm.value,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_fbu'
        })
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
